import React from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useDropzone } from 'react-dropzone';
import { DropArea, DropzoneRoot } from './styled';

export { DropArea } from './styled';
export { useFilePicker } from './useFilePicker';

const Dropzone = ({
  onFilesAccepted,
  onFilesRejected = undefined,
  accept = undefined,
  maxSize = undefined,
  maxFiles = undefined,
  disabled = false,
  renderContent,
  testId = undefined
}) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDropAccepted: onFilesAccepted,
    onDropRejected: onFilesRejected,
    accept,
    maxSize,
    maxFiles,
    disabled
  });

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <DropzoneRoot {...getRootProps()} data-testid={testId}>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <input {...getInputProps()} />
      <DropArea $isDragActive={isDragActive} $isUploading={disabled}>
        {renderContent({ isDragActive })}
      </DropArea>
    </DropzoneRoot>
  );
};

Dropzone.propTypes = {
  onFilesAccepted: PropTypes.func.isRequired,
  onFilesRejected: PropTypes.func,
  accept: PropTypes.string,
  maxSize: PropTypes.number,
  maxFiles: PropTypes.number,
  disabled: PropTypes.bool,
  renderContent: PropTypes.func.isRequired,
  testId: PropTypes.string
};

export default Dropzone;
